import { Tipp } from './Hinweis'

export function Karte({
  titel, neben, werkzeug, children, flach = false,
}: {
  titel?: string
  neben?: React.ReactNode
  werkzeug?: React.ReactNode
  children: React.ReactNode
  flach?: boolean
}) {
  return (
    <section className="karte">
      {(titel || werkzeug) && (
        <div className="karte-kopf">
          {titel && <h2>{titel}</h2>}
          {neben && <Tipp text={neben} />}
          <span className="schieber" />
          {werkzeug}
        </div>
      )}
      <div className="karte-leib" style={flach ? { paddingTop: 8 } : undefined}>
        {children}
      </div>
    </section>
  )
}
